<template>
  <section class="section-wrapp">
    <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>
    <InverterProduction></InverterProduction>
    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="device-graph-table style">
              <div v-if="haveData" class="device-graph style" style="color:#fff">
                <highcharts :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="haveData" >
      <PerformanceRatio :productionAC="chartOptions.series[0].data" ></PerformanceRatio>
    </div>
  </section>
</template>

<script>

import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import '@/../node_modules/flatpickr/dist/themes/dark.css'
import '@/assets/css/js-datapicer.scss'
import graphConfigs from '@/components/graphConfigs'
import object from 'lodash/object'
import moment from 'moment'
import stationApi from '@/api/station'
import InverterProduction from '@/components/analytics/InverterProduction'
import PerformanceRatio from '@/components/analytics/PerformanceRatio.vue'

stockInit(Highcharts)

export default {
  name: 'AnalyticsOld',
  mixins: [graphConfigs],
  components: {
    Breadcrumbs,
    'highcharts': Chart,
    InverterProduction,
    PerformanceRatio
  },
  data () {
    return {
      values: null,
      isActive: false,
      breadcrumbsData: null,
      stationId: null,
      pageTitle: {
        name: 'Афанасиевка',
        power: ''
      },
      haveData: false,
      chartOptions: {
        rangeSelector: {
          buttons: [{
            type: 'day',
            count: 1,
            text: 'Day'
          }, {
            type: 'week',
            count: 1,
            text: 'Week'
          }, {
            type: 'month',
            count: 1,
            text: 'Month'
          },
          {
            type: 'all',
            text: 'All',
            dataGrouping: {
              forced: true,
              units: [['month', [1]]]
            }
          }]
        },
        yAxis: [
          {
            title: {
              style: {
                color: '#fff'
              }
            },
            labels: {
              style: {
                color: '#fff'
              }
            },
            gridLineColor: '#595c5e'
          }
        ],
        chart: {
          marginLeft: 25,
          marginRight: 25,
          type: 'column'
        },
        series: [
          {
            data: [],
            name: 'Actual production'
          },
          {
            data: [],
            name: 'Forecast'
          }
        ],
        tooltip: {
          dateTimeLabelFormats: {
            millisecond: '%A, %b %e'
          }
        }
      }
    }
  },
  created () {
    let id = this.$route.params.id
    let _this = this

    this.$store.dispatch('station/findOne', id).then((station) => {
      _this.breadcrumbsData = [
        {
          url: '/station-view/' + station.id,
          title: station.title
        },
        {
          url: '#',
          title: station.title + ' (Analytics)'
        }
      ]

      _this.$store.dispatch('common/toggleLoading', true)
      stationApi.prodcution(id).then((r) => {
        let data = {}
        _this.$store.dispatch('common/toggleLoading', false)

        if (object.entries(r.data).length > 0) {
          object.forOwn(r.data, (value, date) => {
            let day = moment(date, 'YYYY-MM-DD HH-mm-ss').format('YYYY-MM-DD')

            if (object.has(data, day)) {
              object.set(data, day, (value + object.get(data, day)))
            } else {
              object.set(data, day, value)
            }
          })

          object.forOwn(data, (value, date) => {
            let day = moment(date, 'YYYY-MM-DD')
            let forecastValue = 0

            object.forOwn(station.forecast, (forecastData, month) => {
              if (month === day.format('MM.YYYY')) {
                forecastValue = parseInt(String(forecastData.value).replace(/\D/g, '')) / day.daysInMonth()

                if (forecastData.hasOwnProperty('days')) {
                  object.forOwn(forecastData.days, (forecastDayValue, forecastDayTime) => {
                    if (forecastDayTime === day.format('DD.MM.YYYY')) {
                      forecastValue = parseFloat(forecastDayValue)
                    }
                  })
                }
              }
            })

            day.add(3, 'hours')

            _this.chartOptions.series[0].data.push([day.valueOf(), value])
            _this.chartOptions.series[1].data.push([day.valueOf(), forecastValue])
          })
        } else {
          object.forOwn(station.forecast, (forecastData, month) => {
            let forecastValue = parseInt(String(forecastData.value).replace(/\D/g, ''))

            let day = moment(month, 'MM.YYYY')

            _this.chartOptions.series[0].data.push([day.valueOf(), 0])
            _this.chartOptions.series[1].data.push([day.valueOf(), forecastValue])
          })
        }

        for (let i = 0; i < 2; i++) {
          _this.chartOptions.series[i].data.sort((a, b) => {
            if (a[0] < b[0]) {
              return -1
            }
            if (a[0] > b[0]) {
              return 1
            }

            return 0
          })
        }

        _this.haveData = true
      })
    })
  },
  methods: {
    toggleClass () {
      if (window.innerWidth <= 992) {
        this.isActive = !this.isActive
      }
    }
  }
}
</script>
